export default () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="m3 6 2 2 4-4" stroke="#038331" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);
